import { CarouselTypeParams } from '@environment';

export const carouselTypeParams: CarouselTypeParams = {
  channel: {
    swiperConfig: {
      effect: 'fade',
      speed: 400,
      fadeEffect: {
        crossFade: true
      }
    }
  },
  movies: {
    equalizeHeights: true,

    ammountSlidesMax: 20,
    swiperConfig: {
      slidesPerView: 2,
      breakpoints: {
        576: {
          slidesPerView: 3
        },
        768: {
          slidesPerView: 4
        },
        992: {
          slidesPerView: 5
        },
        1400: {
          slidesPerView: 6
        }
      }
    },
    default: {
      byPage: 6,
      gap: 20,
      arrowLayout: ['top-right']
    },
    options: [
      {
        breakpoint: 1400,
        byPage: 5
      },
      {
        breakpoint: 1200,
        byPage: 4
      },
      {
        breakpoint: 992,
        byPage: 3
      },
      {
        breakpoint: 768,
        byPage: 2
      },
      {
        breakpoint: 576,
        byPage: 1
      }
    ],
    arrowLayout: ['top-right'],
    arrowLayoutDesing: {
      top: 6
    }
  },
  gallery: {
    default: {
      byPage: 5,
      gap: 20,
      arrowLayout: ['top-right']
    },
    options: [
      {
        breakpoint: 1200,
        byPage: 4
      },
      {
        breakpoint: 992,
        byPage: 3
      },
      {
        breakpoint: 768,
        byPage: 2
      },
      {
        breakpoint: 576,
        byPage: 1
      }
    ],
    arrowLayout: ['top-right'],
    arrowLayoutDesing: {
      top: 6
    }
  },
  videos: {
    default: {
      byPage: 5,
      gap: 20,
      arrowLayout: ['top-right']
    },
    options: [
      {
        breakpoint: 1200,
        byPage: 4
      },
      {
        breakpoint: 992,
        byPage: 3
      },
      {
        breakpoint: 768,
        byPage: 2
      },
      {
        breakpoint: 576,
        byPage: 1
      }
    ],
    arrowLayout: ['top-right'],
    arrowLayoutDesing: {
      top: 6
    }
  },
  posters: {
    default: {
      byPage: 6,
      gap: 20,
      arrowLayout: ['top-right']
    },
    options: [
      {
        breakpoint: 1400,
        byPage: 5
      },
      {
        breakpoint: 1200,
        byPage: 4
      },
      {
        breakpoint: 992,
        byPage: 3
      },
      {
        breakpoint: 768,
        byPage: 2
      },
      {
        breakpoint: 576,
        byPage: 1
      }
    ],
    arrowLayout: ['top-right'],
    arrowLayoutDesing: {
      top: 6
    }
  }
};
